<template>
	<div v-if="visible" class="pop-message pop-message__info" :class="!this.visible ? 'pop-message-inactive' : ''">
		<div class="container">
			<div class="pop-message__info-container">
				<div class="icon">
					<img src="images/icons/ic-notification.svg" alt="Notification" title="Notification">
				</div>
				<div class="text" v-html="message.message">
				</div>
				<button class="btn btn-plain msg-close" @click="close">
					<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg?v1.3#icon-close"></use></svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PopMessage",
	props: {
		message: Object
	},
	data: function() {
		return {
			visible: true
		}
	},
	methods: {
		close() {
			this.visible = false;
			sessionStorage.setItem('popVisible', false);
		}
	},
	created: function() {
		let show = sessionStorage.getItem('popVisible');
		if (show != null) {
			this.visible = false;
		}
	}
}
</script>
